import axios from 'axios';
export const LOAD_TEST_DATA = 'load_test_data';
export const SET_ACTIVE_TEST = 'set_active_test';
export const SET_ACTIVE_RESULT = 'set_active_result';

export function addDefaultClient() {
  return (dispatch, getState) => {
    const client = {};
    client.firstName = getState().params.advisorFirstName;
    client.lastName = getState().params.advisorLastName;
    client.email = getState().params.advisorEmail;
    client.advisorEmail = getState().params.advisorEmail;
    client.advisorFirstName = getState().params.advisorFirstName;
    client.advisorLastName = getState().params.advisorLastName;
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: getState().params.apiURL + '/clients/',
      data: client,
    };
    return axios(request)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function getDefaultClient() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: getState().params.apiURL + '/clients/',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      params: {
        advisorEmail: getState().params.advisorEmail,
        lastName: getState().params.advisorLastName,
        limit: 1,
      },
    };
    return axios(request)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function loadTestData(clientID) {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${getState().params.apiURL}/public/clients/${clientID}/`,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: LOAD_TEST_DATA, payload: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function loadData() {
  return (dispatch, getState) => {
    dispatch(getDefaultClient()).then((data) => {
      if(data.length > 0) {
        dispatch(loadTestData(data[0].id));
      } else {
        dispatch(addDefaultClient()).then((data) => {
          dispatch(loadTestData(data.id));
        });
      }
    });
  }
}


export function saveClient(client) {
  return (dispatch, getState) => {
    const request = {
      method: 'PUT',
      url: `${getState().params.apiURL}/public/clients/${client.id}/`,
      data: client,
    };
    return axios(request)
      .then(() => {
        dispatch(loadTestData());
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function setActiveTest(name) {
  console.log ('active test -client', name)
  return (dispatch) => {
    dispatch({ type: SET_ACTIVE_TEST, payload: name });
  };
}

export function saveScore(test, answers) {
  return (dispatch, getState) => {
    const data = {
      name: test,
      answers: answers,
    };
    const request = {
      method: 'POST',
      url: `${getState().params.apiURL}/public/clients/${getState().clientData.testData.id}/test_results/`,
      data: data,
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: SET_ACTIVE_RESULT, payload: response.data });
        dispatch(loadTestData(getState().clientData.testData.id));
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function closeTest() {
  return (dispatch) => {
    dispatch({ type: SET_ACTIVE_TEST, payload: '' });
    dispatch({ type: SET_ACTIVE_RESULT, payload: null });
  };
}



// WEBPACK FOOTER //
// ./src/actions/client.js